import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import desktopBg from '../assets/404/404.png';
import mobileBg from '../assets/404/phone404.png';
import videoOverlay from '../assets/404/desk404.webm';
import logo from '../assets/freakslogo.png'; // Assuming this is the logo to use
import './notfound.css';

const NotFound = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="not-found-container">
            {/* Background Image */}
            <img
                src={isMobile ? mobileBg : desktopBg}
                alt="404 Not Found"
                className="not-found-bg"
            />

            {/* Video Overlay - Only show on desktop if requested, or both? user said "use the webm over those images" */}
            <video
                autoPlay
                loop
                muted
                playsInline
                className="not-found-video"
            >
                <source src={videoOverlay} type="video/webm" />
            </video>

            {/* Logo linking to Home */}
            <img
                src={logo}
                alt="Freaks of Nature"
                className="not-found-logo"
                onClick={() => navigate('/')}
            />
        </div>
    );
};

export default NotFound;
